var _rect, _text, _rect2, _text2, _path, _path2, _text3, _path3, _path4, _text4, _ellipse, _text5, _path5, _path6, _text6, _path7, _path8, _text7, _ellipse2, _text8, _path9, _path10, _text9, _path11, _path12, _text10, _ellipse3, _text11, _path13, _path14, _text12, _ellipse4, _text13, _path15, _path16, _text14, _path17, _path18, _text15, _ellipse5, _text16, _path19, _path20, _text17, _path21, _path22, _text18, _ellipse6, _text19, _rect3, _path23, _text20, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS3SourceOnGoing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1117px",
    height: "482px",
    viewBox: "-0.5 -0.5 1117 482",
    content: "<mxfile host=\"Electron\" modified=\"2023-06-25T02:43:01.701Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/20.3.0 Chrome/104.0.5112.114 Electron/20.1.3 Safari/537.36\" version=\"20.3.0\" etag=\"z1bfGuWLB8WPgW52VAeQ\" type=\"device\"><diagram id=\"Z7jv7MWWAHRbw4NUefr9\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-60a337-1-277116-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(39, 113, 22)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(96, 163, 55)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-ff4f8b-1-bc1356-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(188, 19, 86)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255, 79, 139)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f78e04-1-d05c17-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(208, 92, 23)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(247, 142, 4)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-945df2-1-5a30b5-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(90, 48, 181)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(148, 93, 242)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80,
    width: 350,
    height: 250,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-end",
      justifyContent: "unsafe center",
      width: 348,
      height: 1,
      paddingTop: 327,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Customer ownership")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 327,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Customer ownership")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 80,
    width: 665,
    height: 400,
    fill: "none",
    stroke: "#ff9933",
    strokeWidth: 2,
    strokeDasharray: "6 6",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-end",
      justifyContent: "unsafe center",
      width: 663,
      height: 1,
      paddingTop: 477,
      marginLeft: 451
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FF9933; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(255, 153, 51)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "CLO ownership")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 783,
    y: 477,
    fill: "#FF9933",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "CLO ownership")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 240 180 L 318 180 L 318 258 L 240 258 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 302.28 222.22 L 302.71 219.21 C 306.66 221.57 306.71 222.55 306.71 222.58 C 306.7 222.58 306.03 223.14 302.28 222.22 Z M 300.12 221.62 C 293.3 219.56 283.8 215.2 279.96 213.39 C 279.96 213.37 279.96 213.36 279.96 213.34 C 279.96 211.86 278.76 210.66 277.28 210.66 C 275.81 210.66 274.61 211.86 274.61 213.34 C 274.61 214.82 275.81 216.02 277.28 216.02 C 277.93 216.02 278.52 215.78 278.98 215.39 C 283.51 217.53 292.93 221.82 299.8 223.85 L 297.08 243.03 C 297.07 243.08 297.07 243.13 297.07 243.18 C 297.07 244.87 289.6 247.97 277.39 247.97 C 265.05 247.97 257.49 244.87 257.49 243.18 C 257.49 243.13 257.49 243.08 257.48 243.03 L 251.81 201.57 C 256.72 204.95 267.29 206.74 277.39 206.74 C 287.48 206.74 298.03 204.96 302.96 201.59 Z M 251.21 197.25 C 251.29 195.78 259.71 190.03 277.39 190.03 C 295.07 190.03 303.5 195.78 303.58 197.25 L 303.58 197.75 C 302.61 201.04 291.69 204.51 277.39 204.51 C 263.07 204.51 252.15 201.02 251.21 197.73 Z M 305.81 197.27 C 305.81 193.41 294.74 187.8 277.39 187.8 C 260.05 187.8 248.98 193.41 248.98 197.27 L 249.08 198.11 L 255.27 243.27 C 255.41 248.32 268.88 250.2 277.39 250.2 C 287.94 250.2 299.15 247.77 299.3 243.27 L 301.97 224.44 C 303.45 224.8 304.68 224.98 305.66 224.98 C 306.98 224.98 307.87 224.66 308.41 224.01 C 308.85 223.49 309.02 222.85 308.89 222.16 C 308.61 220.62 306.77 218.96 303.05 216.83 L 305.69 198.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 279
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon S3", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 13
    }
  }), "(Log bucket)")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 279,
    y: 278,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Amazon S3...")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 210 L 213.63 210",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 218.88 210 L 211.88 213.5 L 213.63 210 L 211.88 206.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 241,
      marginLeft: 171
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Output")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 244,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Output")))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 156
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "1"))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "1")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 505 180 L 583 180 L 583 258 L 505 258 Z",
    fill: "url(#mx-gradient-ff4f8b-1-bc1356-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 531.66 223.03 L 534.95 219.79 C 535.15 219.59 535.27 219.31 535.27 219.02 C 535.27 218.73 535.15 218.46 534.95 218.25 L 531.67 214.97 L 530.12 216.5 L 531.52 217.91 L 526.52 217.91 L 526.52 220.09 L 531.54 220.09 L 530.12 221.49 Z M 556.71 223.13 L 561.09 219.87 C 561.36 219.66 561.53 219.34 561.53 219 C 561.53 218.66 561.36 218.33 561.09 218.13 L 556.71 214.87 L 555.4 216.61 L 557.15 217.91 L 552.77 217.91 L 552.77 220.09 L 557.15 220.09 L 555.4 221.39 Z M 538.76 219 C 538.76 221.31 538.36 223.48 537.62 225.38 C 539.58 224.62 541.8 224.24 544.02 224.24 C 546.24 224.24 548.46 224.62 550.43 225.38 C 549.68 223.48 549.28 221.31 549.28 219 C 549.28 216.69 549.68 214.52 550.43 212.62 C 546.49 214.13 541.55 214.13 537.62 212.62 C 538.36 214.52 538.76 216.69 538.76 219 Z M 533.4 229.55 C 533.19 229.34 533.08 229.06 533.08 228.78 C 533.08 228.51 533.19 228.23 533.4 228.01 C 535.39 226.04 536.57 222.67 536.57 219 C 536.57 215.33 535.39 211.96 533.4 209.99 C 533.19 209.77 533.08 209.49 533.08 209.22 C 533.08 208.94 533.19 208.66 533.4 208.45 C 533.83 208.02 534.52 208.02 534.95 208.45 C 539.19 212.66 548.85 212.66 553.09 208.45 C 553.52 208.02 554.21 208.02 554.64 208.45 C 554.85 208.66 554.96 208.94 554.96 209.22 C 554.96 209.49 554.85 209.77 554.64 209.99 C 552.65 211.96 551.47 215.33 551.47 219 C 551.47 222.67 552.65 226.04 554.64 228.01 C 554.85 228.23 554.96 228.51 554.96 228.78 C 554.96 229.06 554.85 229.34 554.64 229.55 C 554.43 229.76 554.15 229.87 553.87 229.87 C 553.59 229.87 553.31 229.76 553.09 229.55 C 548.85 225.34 539.19 225.34 534.95 229.55 C 534.52 229.98 533.83 229.98 533.4 229.55 Z M 572.43 219.01 C 572.43 217.99 572.03 217.04 571.31 216.32 C 570.57 215.58 569.59 215.21 568.61 215.21 C 567.63 215.21 566.66 215.58 565.91 216.32 C 564.42 217.8 564.42 220.21 565.91 221.69 C 567.4 223.17 569.82 223.17 571.31 221.69 C 572.03 220.97 572.43 220.02 572.43 219.01 Z M 572.86 223.22 C 571.69 224.39 570.15 224.97 568.61 224.97 C 567.07 224.97 565.54 224.39 564.36 223.22 C 562.02 220.9 562.02 217.11 564.36 214.79 C 566.71 212.46 570.52 212.46 572.86 214.79 C 575.2 217.11 575.2 220.9 572.86 223.22 Z M 523.2 219.03 C 523.2 218.02 522.81 217.06 522.08 216.35 C 521.36 215.63 520.41 215.24 519.39 215.24 C 518.37 215.24 517.41 215.63 516.69 216.35 C 515.97 217.06 515.57 218.02 515.57 219.03 C 515.57 220.04 515.97 220.99 516.69 221.71 C 518.13 223.14 520.64 223.14 522.08 221.71 C 522.81 220.99 523.2 220.04 523.2 219.03 Z M 523.63 223.25 C 522.46 224.41 520.92 224.99 519.39 224.99 C 517.85 224.99 516.31 224.41 515.14 223.25 C 512.8 220.92 512.8 217.14 515.14 214.81 C 517.48 212.48 521.29 212.48 523.63 214.81 C 525.97 217.14 525.97 220.92 523.63 223.25 Z M 560.29 235.24 C 555.92 239.58 550.11 241.97 543.93 241.97 C 537.75 241.97 531.95 239.58 527.58 235.24 C 524.58 232.27 522.93 228.71 522.08 226.25 L 520.01 226.97 C 520.94 229.64 522.74 233.51 526.03 236.78 C 530.81 241.53 537.17 244.15 543.93 244.15 C 550.7 244.15 557.05 241.53 561.83 236.78 C 564.6 234.04 566.8 230.55 568.03 226.96 L 565.96 226.26 C 564.83 229.54 562.82 232.73 560.29 235.24 Z M 522.08 211.75 L 520.01 211.03 C 521.34 207.25 523.48 203.76 526.04 201.21 C 530.82 196.47 537.17 193.85 543.93 193.85 C 550.69 193.85 557.05 196.47 561.83 201.21 C 564.52 203.89 566.79 207.47 568.03 211.03 L 565.96 211.75 C 564.82 208.49 562.75 205.21 560.28 202.75 C 555.92 198.41 550.11 196.03 543.93 196.03 C 537.76 196.03 531.95 198.41 527.59 202.75 C 525.25 205.07 523.3 208.27 522.08 211.75 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 544
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "SQS")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 544,
    y: 278,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "SQS")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 760 160 L 760 40 L 280 40 L 280 153.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 280 158.88 L 276.5 151.88 L 280 153.63 L 283.5 151.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 56,
      marginLeft: 500
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Read log files and parse")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 59,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Read log files and parse")))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 405,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 391
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "2"))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "2")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 725 180 L 803 180 L 803 258 L 725 258 Z",
    fill: "url(#mx-gradient-f78e04-1-d05c17-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 750.67 247.97 L 736.83 247.97 L 752.13 215.99 L 759.06 230.26 Z M 753.13 212.93 C 752.94 212.55 752.55 212.3 752.13 212.3 L 752.12 212.3 C 751.69 212.3 751.3 212.55 751.12 212.94 L 734.05 248.61 C 733.89 248.95 733.91 249.36 734.11 249.68 C 734.32 250 734.68 250.2 735.06 250.2 L 751.37 250.2 C 751.8 250.2 752.2 249.95 752.38 249.56 L 761.31 230.73 C 761.46 230.43 761.46 230.07 761.31 229.77 Z M 791.88 247.97 L 778.13 247.97 L 756.08 201.81 C 755.9 201.42 755.5 201.17 755.07 201.17 L 746.08 201.17 L 746.09 190.03 L 763.72 190.03 L 785.67 236.19 C 785.85 236.58 786.25 236.83 786.68 236.83 L 791.88 236.83 Z M 793 234.6 L 787.38 234.6 L 765.43 188.44 C 765.25 188.05 764.85 187.8 764.42 187.8 L 744.97 187.8 C 744.36 187.8 743.86 188.3 743.85 188.91 L 743.84 202.28 C 743.84 202.58 743.96 202.86 744.17 203.07 C 744.38 203.28 744.66 203.4 744.96 203.4 L 754.37 203.4 L 776.42 249.56 C 776.61 249.95 777 250.2 777.43 250.2 L 793 250.2 C 793.61 250.2 794.11 249.7 794.11 249.09 L 794.11 235.71 C 794.11 235.1 793.61 234.6 793 234.6 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 764
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "AWS Lambda", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 13
    }
  }), "(Log processor)")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 764,
    y: 278,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "AWS Lambda...")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 595 220 L 708.63 220",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 713.88 220 L 706.88 223.5 L 708.63 220 L 706.88 216.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 241,
      marginLeft: 651
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Trigger")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 651,
    y: 244,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Trigger")))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 650,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 636
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "3"))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "3")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 337.75 212.25 L 473.63 212.01",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 478.88 212 L 471.89 215.51 L 473.63 212.01 L 471.88 208.51 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 241,
      marginLeft: 400
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "S3 notification")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 245,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "S3 notification")))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 505,
    cy: 15,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 15,
      marginLeft: 491
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "4"))))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 19,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "4")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 965 180 L 1043 180 L 1043 258 L 965 258 Z",
    fill: "url(#mx-gradient-945df2-1-5a30b5-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 985.41 206.39 L 973.95 206.39 C 973.31 206.39 972.8 206.9 972.8 207.53 L 972.8 248.81 C 972.8 249.45 973.31 249.96 973.95 249.96 L 985.41 249.96 C 986.05 249.96 986.56 249.45 986.56 248.81 L 986.56 207.53 C 986.56 206.9 986.05 206.39 985.41 206.39 Z M 975.09 247.67 L 975.09 208.68 L 984.27 208.68 L 984.27 247.67 Z M 991.15 214.41 L 988.85 214.41 L 988.85 199.51 C 988.85 198.87 989.37 198.36 990 198.36 L 1001.47 198.36 C 1002.1 198.36 1002.61 198.87 1002.61 199.51 L 1002.61 204.09 L 1000.32 204.09 L 1000.32 200.65 L 991.15 200.65 Z M 1000.32 240.79 L 1002.61 240.79 L 1002.61 248.81 C 1002.61 249.45 1002.1 249.96 1001.47 249.96 L 990 249.96 C 989.37 249.96 988.85 249.45 988.85 248.81 L 988.85 231.61 L 991.15 231.61 L 991.15 247.67 L 1000.32 247.67 Z M 1007.2 202.95 L 1004.91 202.95 L 1004.91 189.19 C 1004.91 188.55 1005.42 188.04 1006.05 188.04 L 1017.52 188.04 C 1018.15 188.04 1018.67 188.55 1018.67 189.19 L 1018.67 205.24 L 1016.37 205.24 L 1016.37 190.33 L 1007.2 190.33 Z M 1016.37 243.08 L 1018.67 243.08 L 1018.67 248.81 C 1018.67 249.45 1018.15 249.96 1017.52 249.96 L 1006.05 249.96 C 1005.42 249.96 1004.91 249.45 1004.91 248.81 L 1004.91 241.93 L 1007.2 241.93 L 1007.2 247.67 L 1016.37 247.67 Z M 1034.72 196.07 L 1034.72 235.05 L 1032.43 235.05 L 1032.43 197.21 L 1023.25 197.21 L 1023.25 209.83 L 1020.96 209.83 L 1020.96 196.07 C 1020.96 195.43 1021.47 194.92 1022.11 194.92 L 1033.57 194.92 C 1034.21 194.92 1034.72 195.43 1034.72 196.07 Z M 1023.32 229.93 C 1024.38 227.78 1024.98 225.36 1024.98 222.81 C 1024.98 213.8 1017.65 206.47 1008.64 206.47 C 999.63 206.47 992.31 213.8 992.31 222.81 C 992.31 231.82 999.63 239.15 1008.64 239.15 C 1011.97 239.15 1015.06 238.14 1017.64 236.43 L 1027.51 245.33 C 1028.33 246.07 1029.37 246.44 1030.4 246.43 C 1031.58 246.43 1032.76 245.96 1033.61 245.01 C 1035.2 243.24 1035.06 240.51 1033.29 238.91 Z M 994.6 222.81 C 994.6 215.06 1000.9 208.76 1008.64 208.76 C 1016.39 208.76 1022.69 215.06 1022.69 222.81 C 1022.69 230.55 1016.39 236.85 1008.64 236.85 C 1000.9 236.85 994.6 230.55 994.6 222.81 Z M 1031.91 243.48 C 1031.16 244.3 1029.88 244.37 1029.04 243.63 L 1019.48 235 C 1020.49 234.1 1021.4 233.09 1022.16 231.97 L 1031.76 240.62 C 1032.58 241.36 1032.65 242.65 1031.91 243.48 Z M 1008.64 211.33 C 1002.31 211.33 997.17 216.48 997.17 222.81 C 997.17 229.14 1002.31 234.28 1008.64 234.28 C 1014.97 234.28 1020.12 229.14 1020.12 222.81 C 1020.12 216.48 1014.97 211.33 1008.64 211.33 Z M 1008.64 231.99 C 1003.58 231.99 999.46 227.87 999.46 222.81 C 999.46 217.74 1003.58 213.62 1008.64 213.62 C 1013.71 213.62 1017.83 217.74 1017.83 222.81 C 1017.83 227.87 1013.71 231.99 1008.64 231.99 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 1004
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon OpenSearch Service")))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1004,
    y: 278,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Amazon OpenS...")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 825 218.71 L 938.63 218.71",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 943.88 218.71 L 936.88 222.21 L 938.63 218.71 L 936.88 215.21 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 239,
      marginLeft: 881
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Upload parsed logs")))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 881,
    y: 243,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Upload parsed logs")))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 880,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 866
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "5"))))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 880,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "5")))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 965 350 L 1043 350 L 1043 428 L 965 428 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 1027.28 392.22 L 1027.71 389.21 C 1031.66 391.57 1031.71 392.55 1031.71 392.58 C 1031.7 392.58 1031.03 393.14 1027.28 392.22 Z M 1025.12 391.62 C 1018.3 389.56 1008.8 385.2 1004.96 383.39 C 1004.96 383.37 1004.96 383.36 1004.96 383.34 C 1004.96 381.86 1003.76 380.66 1002.28 380.66 C 1000.81 380.66 999.61 381.86 999.61 383.34 C 999.61 384.82 1000.81 386.02 1002.28 386.02 C 1002.93 386.02 1003.52 385.78 1003.98 385.39 C 1008.51 387.53 1017.93 391.82 1024.8 393.85 L 1022.08 413.03 C 1022.07 413.08 1022.07 413.13 1022.07 413.18 C 1022.07 414.87 1014.6 417.97 1002.39 417.97 C 990.05 417.97 982.49 414.87 982.49 413.18 C 982.49 413.13 982.49 413.08 982.48 413.03 L 976.81 371.57 C 981.72 374.95 992.29 376.74 1002.39 376.74 C 1012.48 376.74 1023.03 374.96 1027.96 371.59 Z M 976.21 367.25 C 976.29 365.78 984.71 360.03 1002.39 360.03 C 1020.07 360.03 1028.5 365.78 1028.58 367.25 L 1028.58 367.75 C 1027.61 371.04 1016.69 374.51 1002.39 374.51 C 988.07 374.51 977.15 371.02 976.21 367.73 Z M 1030.81 367.27 C 1030.81 363.41 1019.74 357.8 1002.39 357.8 C 985.05 357.8 973.98 363.41 973.98 367.27 L 974.08 368.11 L 980.27 413.27 C 980.41 418.32 993.88 420.2 1002.39 420.2 C 1012.94 420.2 1024.15 417.77 1024.3 413.27 L 1026.97 394.44 C 1028.45 394.8 1029.68 394.98 1030.66 394.98 C 1031.98 394.98 1032.87 394.66 1033.41 394.01 C 1033.85 393.49 1034.02 392.85 1033.89 392.16 C 1033.61 390.62 1031.77 388.96 1028.05 386.83 L 1030.69 368.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 435,
      marginLeft: 1004
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon S3", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 13
    }
  }), "(Failed log bucket)")))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 1004,
    y: 448,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Amazon S3...")))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 755 310 L 755 390 L 938.63 390",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 943.88 390 L 936.88 393.5 L 938.63 390 L 936.88 386.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 411,
      marginLeft: 881
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Write failed logs")))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 881,
    y: 414,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Write failed logs")))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 880,
    cy: 365,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 365,
      marginLeft: 866
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "6"))))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 880,
    y: 369,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "6")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 170,
    width: 64,
    height: 78,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 55.02 221.63 L 81.38 221.63 L 81.38 218.08 L 55.02 218.08 Z M 55.02 210.77 L 87.58 210.77 L 87.58 207.23 L 55.02 207.23 Z M 55.02 199.92 L 68.98 199.92 L 68.98 196.38 L 55.02 196.38 Z M 33.55 232.03 L 34.87 232.03 L 34.87 235.58 L 31.77 235.58 C 30.79 235.58 30 234.78 30 233.8 L 30 171.8 C 30 170.82 30.79 170.02 31.77 170.02 L 61.23 170.02 L 61.23 173.57 L 33.55 173.57 Z M 42.85 238.23 L 45.72 238.23 L 45.72 241.78 L 41.07 241.78 C 40.09 241.78 39.3 240.98 39.3 240 L 39.3 178 C 39.3 177.02 40.09 176.22 41.07 176.22 L 68.98 176.22 L 68.98 179.77 L 42.85 179.77 Z M 52.15 244.43 L 52.15 185.97 L 74.95 185.97 L 74.95 199.7 C 74.95 200.68 75.75 201.47 76.73 201.47 L 90.45 201.47 L 90.45 244.43 Z M 78.5 188.48 L 87.95 197.92 L 78.5 197.92 Z M 93.48 198.44 L 77.98 182.94 C 77.65 182.61 77.2 182.42 76.73 182.42 L 50.37 182.42 C 49.4 182.42 48.6 183.22 48.6 184.2 L 48.6 246.2 C 48.6 247.18 49.4 247.98 50.37 247.98 L 92.23 247.98 C 93.21 247.98 94 247.18 94 246.2 L 94 199.7 C 94 199.23 93.81 198.78 93.48 198.44 Z",
    fill: "#232f3d",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 255,
      marginLeft: 62
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Source", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 13
    }
  }), "(Log files)")))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 268,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Source..."))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3SourceOnGoing);
export default __webpack_public_path__ + "static/media/s3-source-on-going.516e9c1916e8d0f71f40e6cb6a228e44.svg";
export { ForwardRef as ReactComponent };